<script>
  import { onMount } from "svelte";
  import {External, M} from "../external";

  export let customClass = "";
  let showWarning = false;
  let showButton = false;
  let message = "";

  onMount(() => {
    let details = External.Website.marketing;
    showWarning = !details.canRunMarketingJobs;
    showButton = External.Website.hasPermission(External.Permission.BILLING);

    if (showWarning) {
      if (details.riskThresholdReached) {
        message = M.MARKETING_PAUSED_REPUTATION;
        showButton = false;
      } else if (!details.withinAllowance) {
        message = M.MARKETING_PAUSED_ALLOWANCE;
        showButton = false;
      } else if (!details.withinPlanLimits) {
        message = M.MARKETING_PAUSED_LIMITS;
      }
    }
  });
</script>

{#if showWarning}
  <div class="limit-warning-line flex align-center col20 {customClass}">
    <span class="material-icons flex-none"> error </span>
    <div class="flex-1">
      <h4 class="col20 f-left mb-10">{M.MARKETING_LIMITED}</h4>
      <span class="col20 f-left">{message}</span>
    </div>
    {#if showButton}
      <a href="/me/settings/billing?show=marketing" rel="tab" class="middle-button white-btn flex-none rounded-effect">{M.INCREASE_LIMITS}</a>
    {/if}
  </div>
{/if}
